import EventEmitter from '../eventEmitter';
import storage from 'root/common/util/storage.js';

// export const LOCATION_CHOOSE_CITY_KEY = 'locationChooseCity';
export const LOCATION_POSITION_CITY_KEY = 'locationPositionCity';
export const LOCATION_POSITION_KEY = 'locationPosition';
export const LOCATION_FLAG_KEY = 'locationFlag';
// 自动定位的时间
// 默认一天
// const autoLocationTime = 5 * 1000;
const autoLocationTime = 24 * 60 * 60 * 1000;
const positionCacheTime = 20 * 1000;

// export const defaultCity = {
//     id: '102923',
//     letter: 'G',
//     cityCn: '广州',
//     cityCode: '440100',
//     lat: 23.12911,
//     lng: 113.264385,
//     isDefaultCity: true,
// };

export const defaultCity = {
    cityCn: '北京',
    cityCode: '110000',
    id: '435',
    lat: 39.904211,
    letter: 'B',
    lng: 116.407395,
    isDefaultCity: true,
};

export function getCacheObj(key) {
    try {
        let value = localStorage.getItem(key);
        return value && typeof value !== 'undefined' ? JSON.parse(value) : undefined;
    } catch (err) {
        return undefined;
    }
}

let watchIntervalId = null;

const locationUtil = {
    defaultCity: defaultCity,

    eventEmitter: new EventEmitter(),

    positionFlagMap: {
        loading: 'loading',
        done: 'done',
        fail: 'fail',
    },

    // 设置过期时间
    setAutoToggleTime(key) {
        let currentKey = storage.keys.locationAutoToggleTime;
        //外卖判断定位弹窗时间缓存兼容处理
        if (key) {
            currentKey = key;
        }
        let expiredTime = new Date().getTime() + autoLocationTime;
        // storage.setNative(storage.keys.locationAutoToggleTime, expiredTime, { namespace: 'vipCard' });
        return storage.set(currentKey, expiredTime);
    },

    // 是否需要自动切换城市
    needAutoToggleCity(key) {
        let currentKey = storage.keys.locationAutoToggleTime;
        //外卖判断定位弹窗时间缓存兼容处理
        if (key) {
            currentKey = key;
        }
        let expiredTime = storage.get(currentKey) || 0;
        return new Date().getTime() > expiredTime;
    },

    // 选择的城市信息
    setChooseCityCache(locationInfo = {}) {
        if (locationInfo && (!locationInfo.id || !locationInfo.cityCn)) {
            window.monitor &&
                window.monitor.report({
                    level: 'info',
                    error: 'js',
                    msg: `setChooseCityCache error: ${JSON.stringify(locationInfo)}`,
                });
        }
        // ios 2.16.0 版本写入缓存的城市id只能为string
        if (window.navigator.userAgent.startsWith('ZZCIOS/black/2.16.0')) {
            locationInfo.id = String(locationInfo.id);
        }
        storage.setNative(storage.keys.locationChooseCity, locationInfo, { namespace: 'vipCard' });
        return storage.set(storage.keys.locationChooseCity, locationInfo);
    },

    // 缓存的选择城市信息
    getChooseCityCache() {
        const chooseCity = storage.get(storage.keys.locationChooseCity);
        if (chooseCity && (!chooseCity.id || !chooseCity.cityCn)) {
            window.monitor &&
                window.monitor.report({
                    level: 'info',
                    error: 'js',
                    msg: `getChooseCityCache error: ${JSON.stringify(chooseCity)}`,
                });
            return null;
        }
        return chooseCity;
    },

    // 缓存定位信息
    setPositionCityCache(locationInfo = {}) {
        if (!locationInfo.lat || !locationInfo.lng) {
            window.monitor &&
                window.monitor.report({
                    level: 'info',
                    error: 'js',
                    msg: `setPositionCityCache error: ${JSON.stringify(locationInfo)}`,
                });
        }

        return localStorage.setItem(LOCATION_POSITION_CITY_KEY, JSON.stringify(locationInfo));
    },
    // 获取缓存的定位信息
    getPositionCityCache() {
        const positionCity = getCacheObj(LOCATION_POSITION_CITY_KEY);
        if (positionCity && (!positionCity.lat || !positionCity.lng)) {
            window.monitor &&
                window.monitor.report({
                    level: 'info',
                    error: 'js',
                    msg: `getPositionCityCache error: ${JSON.stringify(positionCity)}`,
                });
        }

        return positionCity;
    },

    // 缓存定位经纬度信息
    setPositionCache(locationInfo = {}) {
        if (locationInfo && (!locationInfo.latitude || !locationInfo.longitude)) {
            window.monitor &&
                window.monitor.report({
                    level: 'info',
                    error: 'js',
                    msg: `setPositionCache error: ${JSON.stringify(locationInfo)}`,
                });
        }
        return localStorage.setItem(LOCATION_POSITION_KEY, JSON.stringify(locationInfo));
    },

    // 获取缓存的定位经纬度信息
    getPositionCache() {
        return getCacheObj(LOCATION_POSITION_KEY);
    },

    // 定位标识
    setPositionFlag(locationFlag) {
        let saveData = {
            flag: locationFlag,
            expiredTime: new Date().getTime() + positionCacheTime,
        };
        return localStorage.setItem(LOCATION_FLAG_KEY, JSON.stringify(saveData));
    },

    // 标识
    getPositionFlag() {
        let saveData = getCacheObj(LOCATION_FLAG_KEY);
        if (saveData) {
            // loading的时候，判断下上次设置loading的时间
            if (saveData.flag === this.positionFlagMap.loading) {
                return new Date().getTime() < saveData.expiredTime ? saveData.flag : null;
            } else {
                return saveData.flag;
            }
        }
        return null;
    },

    // 判断是否相同城市
    isSameCity(cityA, cityB) {
        if (!(cityA && cityB)) {
            return false;
        }
        return cityA.cityCn === cityB.cityCn;
    },

    // 监听定位是否完成，这里用于app
    watchPositionChange() {
        if (watchIntervalId === null) {
            watchIntervalId = setInterval(() => {
                let flag = this.getPositionFlag();
                if (flag === this.positionFlagMap.done) {
                    this.eventEmitter.trigger('positionDone');
                    clearInterval(watchIntervalId);
                    watchIntervalId = null;
                }
            }, 1000);
        }
    },
};

export default locationUtil;
